module.exports = __webpack_public_path__ + "static/media/movieType-romcom.2e31b088.jpg";